/*
 * Copyright (c) 2020. American Express Company
 */

import queryString from 'query-string';
import BWDataService from './bw-data.service';
import TrackingService from './tracking.service';
import UrlHelper from 'src/utils/url.helper';

export interface ErrorRecoveryMessage {
    error: Error;
    info: { componentStack: string };
    path: string;
    recoverable: boolean;
}
export default class ErrorBoundaryService {
    public static async recover(error: Error, info: { componentStack: string }): Promise<void> {
        const message: ErrorRecoveryMessage = {
            error,
            info,
            path: window.location.pathname,
            recoverable: true
        };

        const performRecovery = (): void => {
            console.error('Recovering from fatal error', error);
            BWDataService.clearUser();
            // set this to prevent infinite refreshes in an unrecoverable state
            UrlHelper.replacePath('?recovery=true');
        };

        try {
            await TrackingService.track(message);
            if (window.location.search) {
                const params: any = queryString.parse(window.location.search);
                if (params.recovery) {
                    message.recoverable = false;
                    await TrackingService.track(message);
                    // Now stealthily remove the search param from the URL bar and history
                    window.history.replaceState(null, null, window.location.pathname);
                    return;
                }
            }
            performRecovery();
        } catch (e) {
            performRecovery();
        }
    }
}
